const ua = () =>
    typeof navigator !== 'undefined' ? navigator.userAgent || '' : ''

export function isInstagramInAppBrowser(): boolean {
    return /Instagram/i.test(ua())
}

export function isFacebookInAppBrowser(): boolean {
    return /FBAN|FBAV/i.test(ua())
}

export function isLineInAppBrowser(): boolean {
    return /Line\//i.test(ua())
}

/** Navegadores embutidos (Instagram, Facebook, Line, etc.) */
export function isInAppBrowser(): boolean {
    return isInstagramInAppBrowser() || isFacebookInAppBrowser() || isLineInAppBrowser()
}

export function inAppBrowserLabel(): string {
    if (isInstagramInAppBrowser()) return 'Instagram'
    if (isFacebookInAppBrowser()) return 'Facebook'
    if (isLineInAppBrowser()) return 'Line'
    return 'este aplicativo'
}

/**
 * Tenta abrir a URL atual no navegador externo.
 * No Android usa intent:// para o Chrome; em iOS/in-app o mais confiável é o menu do app.
 */
export function openInExternalBrowser(): void {
    if (typeof window === 'undefined') return

    const url = window.location.href

    if (/Android/i.test(ua())) {
        const path = url.replace(/^https?:\/\//, '')
        const intentUrl = `intent://${path}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`
        window.location.href = intentUrl
        return
    }

    window.open(url, '_blank', 'noopener,noreferrer')
}

export function externalBrowserInstructions(): string {
    if (isInstagramInAppBrowser()) {
        return 'Toque em ⋯ (três pontos) e escolha "Abrir no navegador externo".'
    }
    if (/Android/i.test(ua())) {
        return 'Toque no menu ⋮ e escolha "Abrir no Chrome" ou "Abrir no navegador".'
    }
    return 'Toque em ⋯ ou no ícone de compartilhar e escolha "Abrir no Safari" ou "Abrir no Chrome".'
}
